import React, {
  createRef,
  useEffect,
  useState
} from 'react';

import PropTypes from 'prop-types';

import './OTPInput.css';

function OTPInput(props) {

  const [ otp, setOtp ] = useState(Array(props.noOfDigits).join('.').split('.'));
  const [ currentIndex, setCurrentIndex ] = useState(0);

  const [ inputRefsArray ] = useState(() =>
    Array.from({ length: props.noOfDigits }, () => createRef())
  );

  function focusPrevIndex(event, current) {

    if (event.key === 'Backspace' && !otp[current] && current > 0) {
      const prevIndex = current - 1;
      const nextInput = inputRefsArray?.[prevIndex]?.current;
      nextInput.focus();
      nextInput.select();
      setCurrentIndex(prevIndex);
    }
  }

  function focusNextIndex(prevIndex) {
    const nextIndex = prevIndex < props.noOfDigits - 1 ? prevIndex + 1 : 0;
    const nextInput = inputRefsArray?.[nextIndex]?.current;
    nextInput.focus();
    nextInput.select();
    setCurrentIndex(nextIndex);
  }

  function otpOnChange(event, index) {
    const value = event.target.value.trim();
    
    // Allow empty value (backspace/delete)
    if (value === '') {
      let otpCpy = [...otp];
      otpCpy[index] = '';
      setOtp(otpCpy);
      props.otpHandler(otpCpy.join(''));
      focusPrevIndex(event, currentIndex)
      return;
    }
      // Block non-digits
    if (!/^\d$/.test(value)) {
      return;
    }

    let otpCpy = [...otp];
    otpCpy[index] = value;
    setOtp(otpCpy);
    props.otpHandler(otpCpy.join(''));
    focusNextIndex(currentIndex);
  }

  useEffect(() => {
    if (inputRefsArray?.[0]?.current) {
      inputRefsArray[0].current.focus();
    }
  }, []);

  return (
    <div className='otp-input'>
      {
      inputRefsArray?.map((ref, index) => {
        return (
          <input
            ref={ref}
            key={index}
            className='otp-input-item'
            value={otp[index]}
            inputMode='numeric'
            pattern='[0-9]*'
            id={index}
            minLength={1}
            maxLength={1}
            onChange={(event) => otpOnChange(event, index)}
            onKeyDown={(event) => {
              focusPrevIndex(event, index)}
            }
            onClick={(e) => {
              setCurrentIndex(index);
              e.target.select();
            }}
          />
        );
      })
      }
    </div>
  );
}

OTPInput.propTypes = {
  noOfDigits: PropTypes.number.isRequired,
  otpHandler: PropTypes.func.isRequired
};

export default OTPInput;